// extracted by mini-css-extract-plugin
export default {"container":"NewOrderSummary_container__dyOJc","mainContent":"NewOrderSummary_mainContent__g11fJ","sidePanel":"NewOrderSummary_sidePanel__GydPZ"};